<template>
  <el-radio-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-radio-button
      v-for="streamLabel in streams"
      :key="streamLabel.stream"
      :value="streamLabel.stream"
    >
      <StreamIcon :stream-id="streamLabel.stream" />
      {{ streamLabel.label }}
    </el-radio-button>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-option
      v-for="streamLabel in streams"
      :key="streamLabel.stream"
      :label="streamLabel.label"
      :value="streamLabel.stream"
    >
      <StreamIcon :stream-id="streamLabel.stream" />
      {{ streamLabel.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import StreamIcon from '@/components/StreamIcon.vue'
import { StreamLabels, StreamLabel } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'StreamSelector',
  components: {
    StreamIcon
  },
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowedStreams: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const update = function (newValue: any) {
      context.emit('update:modelValue', parseInt(newValue))
    }

    const streams = computed(() => {
      if (!props.allowedStreams.length) return StreamLabels

      return StreamLabels.filter((label: StreamLabel) =>
        props.allowedStreams.includes(label.stream)
      )
    })

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    const { isDesktop } = useResize()

    return { update, isDesktop, StreamLabels, streams, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
